export default __webpack_public_path__ + "static/media/vulnerability-assement.ad3dd7df.png";